// Hideo - the Pinia instance, created and made active before anything uses a store (loadApp creates the stores while the
// app loads, before the Vue app installs it with app.use(pinia)).
import { createPinia, setActivePinia } from 'pinia'

export const pinia = createPinia()
setActivePinia(pinia)
